<template>
  <div ref="appAnalyseRef" class="app-engine-analyse">
    <template v-for="chartConfig in chartsConfig">
      <app-engine-analyse-item
        :key="chartConfig.uuid"
        :chartConfig="chartConfig"
      ></app-engine-analyse-item>
    </template>
  </div>
</template>

<script>
import apis from '@/api'
import AppEngineAnalyseItem from './app-engine-analyse-item/app-engine-analyse-item'

export default {
  name: 'AppEngineAnalyse',
  components: {
    AppEngineAnalyseItem
  },
  data() {
    return {
      queryParams: {},
      chartsConfig: []
    }
  },
  created() {
    this.queryParams = this.$route.query
    this.queryAnalyseConfig()
  },
  methods: {
    sortByxy(charts) {
      return charts.sort((a, b) => {
        if (a.posi.y === b.posi.y) {
          return a.posi.x - b.posi.x
        } else {
          return (a.posi.y + a.posi.h) - (b.posi.y + b.posi.h)
        }
      })
    },
    queryAnalyseConfig() {
      const request = {
        ...apis.FORM.QUERY_CHARTS_CONFIG,
        params: {
          reportFormId: this.queryParams.formId
        }
      }
      this.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          this.chartsConfig = this.sortByxy(resp.data.reportCharts)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.app-engine-analyse {
  height: 100%;
  background-color: $--app-body-bgColor;
  padding: 0.71rem 1.14rem;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
